import {
  Directive,
  ElementRef,
  Input,
  Optional,
  Renderer2,
  SkipSelf,
} from '@angular/core';
import {
  FlexDirective as FlexLayoutFlexDirective,
  LayoutDirective as FlexLayoutLayoutDirective,
  LayoutWrapDirective as FlexLayoutLayoutWrapDirective,
  MediaMonitor,
} from '@angular/flex-layout';

@Directive({
  selector: `
    [flLayoutFlex],
    [flLayoutFlex.mobile],
    [flLayoutFlex.tablet],
    [flLayoutFlex.desktop-small],
    [flLayoutFlex.desktop-large],
    [flLayoutFlex.desktop-xlarge],
    [flLayoutFlex.desktop-xxlarge],
  `,
})
export class FlexDirective extends FlexLayoutFlexDirective {
  constructor(
    monitor: MediaMonitor,
    elRef: ElementRef,
    renderer: Renderer2,
    @Optional()
    @SkipSelf()
    protected _container: FlexLayoutLayoutDirective,
    @Optional()
    @SkipSelf()
    protected _wrap: FlexLayoutLayoutWrapDirective,
  ) {
    super(monitor, elRef, renderer, _container, _wrap);
  }

  @Input('flLayoutFlex')
  set flex(val: any) {
    this._cacheInput('flex', val);
  }
  @Input('flLayoutFlex.mobile')
  set flexMobile(val: any) {
    this._cacheInput('flexMobile', val);
  }
  @Input('flLayoutFlex.tablet')
  set flexTablet(val: any) {
    this._cacheInput('flexTablet', val);
  }
  @Input('flLayoutFlex.desktop-small')
  set flexDesktopSmall(val: any) {
    this._cacheInput('flexDesktopSmall', val);
  }
  @Input('flLayoutFlex.desktop-large')
  set flexDesktopLarge(val: any) {
    this._cacheInput('flexDesktopLarge', val);
  }
  @Input('flLayoutFlex.desktop-xlarge')
  set flexDesktopXLarge(val: any) {
    this._cacheInput('flexDesktopXLarge', val);
  }
  @Input('flLayoutFlex.desktop-xxlarge')
  set flexDesktopXXLarge(val: any) {
    this._cacheInput('flexDesktopXXLarge', val);
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/pl/webapp/src/app/@shared/ui/layout/flex.directive.ts